import React, { useState, useEffect } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";
import UnapprovedProduce from "./UnapprovedProduce";
import ApprovedProduce from "./ApprovedProduce";
import ExpiredProduce from "./ExpiredProduce";

const AmtplProduce = () => {
    const [activeTab, setActiveTab] = useState("Unapprove Produce");
    const tabs = ["Unapprove Produce", "Approved Produce",  "Expired Produce" ];

    const renderTabContent = () => {
        switch (activeTab) {
            case "Unapprove Produce":
                return <UnapprovedProduce />;
            case "Approved Produce":
                return <ApprovedProduce />;
            case "Expired Produce":
                return <ExpiredProduce />;
            default:
                return <UnapprovedProduce />; // Added return statement
        }
    };

    return (
        <div className="buyer-layout">
            <div className="amtpl-tabs">
                <div className="content3">
                    <main className="main-content">
                        <div className="mb-3 main-tab">
                            {tabs.map((tab) => (
                                <button
                                    key={tab}
                                    className={`buttonclass ${activeTab === tab ? "active" : "notactive"}`}
                                    onClick={() => setActiveTab(tab)}
                                >
                                    {tab}
                                </button>
                            ))}
                        </div>
                        <div className="row">{renderTabContent()}</div>
                    </main>
                </div>
            </div>
        </div>
    );
};

export default AmtplProduce;